// Helper assíncrono para GPS. Nunca bloqueia a UI:
// - Wrapper Promise do `navigator.geolocation.getCurrentPosition` (a API nativa é async)
// - Timeout curto (8s) + fallback silencioso {latitude:null, longitude:null}
// - Deduplicação de chamadas: se uma captura já está em curso, novos callers
//   reutilizam a MESMA Promise em vez de disparar múltiplos getCurrentPosition
//   em paralelo (comum no mobile quando o usuário toca "Concluir" duas vezes rápido).
// - Cache leve de 30s: se um GPS foi resolvido há menos de 30s, retorna o valor
//   memoizado (poupa bateria + latência). maximumAge do browser API é 60s mas
//   depende de quem chamou primeiro — nosso cache é global para toda a app.

let inflight = null;
let cached = null;      // { latitude, longitude, at }
const CACHE_MS = 30_000;
const TIMEOUT_MS = 8_000;

export function getGPSAsync() {
  // Cache HIT — retorna imediatamente sem tocar geolocation API
  if (cached && Date.now() - cached.at < CACHE_MS) {
    return Promise.resolve({ latitude: cached.latitude, longitude: cached.longitude });
  }
  // Dedup — retorna a Promise em andamento se alguém já pediu GPS
  if (inflight) return inflight;

  inflight = new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve({ latitude: null, longitude: null });
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const val = { latitude: pos.coords.latitude, longitude: pos.coords.longitude };
        cached = { ...val, at: Date.now() };
        resolve(val);
      },
      () => resolve({ latitude: null, longitude: null }),
      { enableHighAccuracy: true, timeout: TIMEOUT_MS, maximumAge: 60_000 }
    );
  }).finally(() => { inflight = null; });

  return inflight;
}

// Utilitário: força invalidação do cache (usado após "Sair" ou troca de entregador).
export function invalidateGPSCache() { cached = null; }
